import React from 'react';
import { stripHtml } from '../../utils/stripHtml';
import { Card, CardBody } from '../../components/card/card.jsx';

export default function MixlistCard({ mixlist, onClick, className = '' }) {
  const descriptionText = stripHtml(mixlist.description);
  const imgUrl = mixlist.image?.url;
  const imgAlt = mixlist.image?.alt || mixlist.name || 'Mixlist image';

  return (
    <Card
      role="button"
      onClick={e => {
        e.preventDefault();
        onClick();
      }}
      className={`h-100 d-flex flex-column cursor-pointer text-body text-decoration-none ${className}`}
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label={`View mixlist: ${mixlist.name}`}
    >
      <CardBody className="p-4 d-flex flex-column flex-grow-1">
        <img
          src={imgUrl}
          alt={imgAlt}
          className="img-fluid rounded mb-3"
          style={{ backgroundColor: '#fff' }}
        />
        <h5 className="mb-2 text-truncate">{mixlist.name} Mixlist</h5>
        {mixlist.description && (
          <p className="text-body text-opacity-75 mb-3 flex-grow-1">
            {descriptionText}
          </p>
        )}
        {/* <button
          type="button"
          className="btn btn-sm btn-outline-theme mt-auto"
          onClick={e => {
            e.stopPropagation();
            onClick();
          }}
        >
          View Mixlist
        </button> */}
      </CardBody>
      {/* ...arrows */}
    </Card>
  );
}
